export default __webpack_public_path__ + "static/media/avatar_dog3.4cbb0596.mp3";